import {Component, Input} from '@angular/core';
import {UploadService} from "../../service/upload.service";
import {Property} from "../../model/property";

/**
 * Upload one file(authority) mapped by a property
 */
@Component({
  selector: 'app-dropzone-connect',
  templateUrl: './dropzone-connect.component.html',
  styleUrls: ['./dropzone-connect.component.css']
})
export class DropzoneConnectComponent {

  constructor(private uploadService: UploadService) { }

  //POST URL for posting an added file
  @Input() uploadUrl: string;
  //Text and Image that are being displayed inside the Component
  @Input() dropzoneText = "";
  @Input() dropzoneImage;
  @Input() allowedInputs: string[] = ["application/pdf"];

  @Input() maxNumberOfFiles = 1;
  @Input() maxFileSize: number = 20000000;
  errorMessage: string;

  files: any = [];
  authorityMap = new Map();

  uploadFile(event: FileList): void {
    const verifyFiles = this.isValidFileSize(event);
    const filesToPush = [];
    // if the files did not pass the verification the result is true and a message contains the problem
    if (verifyFiles.result) {
      this.errorMessage = verifyFiles.message;
      return;
    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];

      if (element.size <= 0) {
        this.errorMessage = "Ihre Datei ist zu klein. Das kann vorkommen, wenn Sie die Datei zum Beispiel aus einem ZIP Ordner hochladen ohne diesen vorher zu entpacken."
        return;
      }
      if (element.size > this.maxFileSize) {
        this.errorMessage = `Die Datei darf nicht größer als ${this.maxFileSize/1000000} MB sein.`
        return;
      }
      if (!this.allowedInputs.some(allowedInput => allowedInput === element.type)) {
        this.errorMessage = "Bitte laden Sie nur " + this.getFileExtensionsByAllowedTypes(this.allowedInputs) + " Dateien hoch"
        return
      }

      filesToPush.push(element);
      this.errorMessage = "";
    }

    this.files = [...filesToPush];
  }

  /**
   * Verifies if the files are valid (filesize bigger than 0 bytes) and together not more than the maximum of 15 MB
   * @param files The passed files to verify
   */
  isValidFileSize(files: FileList): { result: boolean, message: string } {
    let cumulatedFileSize = 0;
    for (let index = 0; index < files.length; index++) {
      const element = files[index];

      if (element.size <= 0) {
        return {result: true, message: "Ihre Datei ist zu klein. Das kann vorkommen, wenn Sie die Datei zum Beispiel aus einem ZIP Ordner hochladen ohne diesen vorher zu entpacken."};
      } else {
        cumulatedFileSize+= element.size;
      }
    }

    return {result: cumulatedFileSize >= this.maxFileSize, message: `Die maximale Größe der Datei(en) darf ${this.maxFileSize/1000000} MB nicht überschreiten.`};
  }

  /**
   * Adds all files of this.files to the given property in the indexedDb. Therefor a hash is created from the property
   *
   * @param property Property to which the files should be added
   */
  public uploadAuthorityMap(property:Property): void{
    this.files.forEach(f =>{
      this.uploadService.saveFile(f, this.uploadService.createPropertyHash(property), "authority");
    })
  }

  deleteAttachment(index) {
    this.files.splice(index, 1)
    this.errorMessage = "";
  }

    /**
     * Converts a list of allowed input typed to their shortened forms and returns them as a comme separated string
     *
     * @param allowedInputs Array of all full length allowed inputs (e.g. ["application/pdf"])
     * @return A comma separated string containing all shortened forms of the allowed inputs
     */
    private getFileExtensionsByAllowedTypes(allowedInputs: string[]) {
        const shortenedForms: string[] = [];

        for (const allowedInput of allowedInputs) {
            const parts: string[] = allowedInput.split('/');
            if (parts.length === 2) {
                const extension = parts[1];
                shortenedForms.push(`.${extension}`);
            }
        }

        return shortenedForms.join(', ');
    }

  /**
   * Generates comma separated string for the 'accept' attribute for an input based on the allowed inputs array
   *
   * @param allowedInputs Array of all full length allowed inputs (e.g. ["application/pdf"])
   * @return A comma separated string containing all allowed types for an input
   */
  public generateAcceptString(allowedInputs: string[]){
      return allowedInputs.join(",");
    }

}
